import { combineReducers } from "redux";
import auth from "./auth";
import agents from "./agents";
import orders from "./orders";
import notifications from "./notifications";
import loansAndSettlements from "./loansAndSettlements";
import errors from "./errors";

export default combineReducers({
  auth,
  orders,
  agents,
  notifications,
  loansAndSettlements,
  errors,
});
